import React, { FC } from "react";
import { IInputProps } from "../../../modules/form";
import TextInput from "react-autocomplete-input";
import "react-autocomplete-input/dist/bundle.css";

export const InputAutoComplete: FC<IInputProps> = ({ onSelectedChange, onChange, onTouched, value, options }) => {
  return (
    <TextInput
      options={options}
      onRequestOptions={onChange}
      trigger={""}
      defaultValue={value || null}
      matchAny={true}
      onChange={onChange}
      Component="input"
      maxOptions="10"
      spacer=""
      minChars="0"
      passThroughEnter={true}
      passThroughTab={true}
      onSelect={onSelectedChange}
      placeholder={"Vui lòng nhập đơn vị"}
    />
  );
};
